export const modalStatus = {
  UNSET: 0,
  SET: 1,
  GRANTED: 2,
};
